import axios from 'axios'
import { DocumentResponse } from '../../../../api/models'
import { UpdateDocumentRequestV3 } from '../../../../api/models/update-document-request-v3'
import { CreateDocumentRequestV3 } from '../../../../api/models/create-document-request-v3'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchConsignmentItemDocumentsV3(
  params: { consignmentItemId: number; documentType?: string },
  opts?: { signal?: AbortSignal },
) {
  const { data } = await axios.get<DocumentResponse[]>(`${baseUrl}/v3/consignment-item/${params.consignmentItemId}/documents`, {
    signal: opts?.signal,
    params: {
      documentType: params.documentType,
    },
  })

  return data
}

export async function createConsignmentItemDocumentsV3(
  consignmentItemId: number,
  documents: CreateDocumentRequestV3[],
) {
  const { data } = await axios.post<DocumentResponse[]>(`${baseUrl}/v3/consignment-item/${consignmentItemId}/documents`, documents)
  return data
}

export async function updateConsignmentItemDocumentsV3(
  consignmentItemId: number,
  documents: UpdateDocumentRequestV3[],
) {
  const { data } = await axios.put<DocumentResponse[]>(`${baseUrl}/v3/consignment-item/${consignmentItemId}/documents`, documents)
  return data
}
